// Auth Helper
/**
 * get user cookie info
 */
export const getLoggedUserCookie = async function () {
	return new Promise((resolve, reject) => {
		let localUser = localStorage.getItem("uResaNinja");
		// get cookie if no local user exist
		let decodedCookie = getCookie("uResaNinja");
		if (!localUser && decodedCookie !== "") {
			localUser = decodedCookie;
		}
		// if no cookie datas or local user
		if (!localUser)
			reject(new Error("No cookie user for resa ninja is present"));
		else {
			const user = JSON.parse(localUser);
			resolve(user);
		}
	});
};

function getCookie(cname) {
	let name = `${cname}=`;
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

export const urlBase64ToUint8Array = function (base64String) {
	var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
	var base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

	var rawData = window.atob(base64);
	var outputArray = new Uint8Array(rawData.length);

	for (var i = 0; i < rawData.length; ++i) {
		outputArray[i] = rawData.charCodeAt(i);
	}
	return outputArray;
};

/**
 * set user cookie info
 */
export const storeUserCookie = async function (userData) {
	if (userData) {
		let userDataModified = {
			token: userData.token,
			user: {
				createdAt: userData.user.createdAt,
				email: userData.user.email,
				id: userData.user.id,
				restoid: userData.user.restoid,
				role: userData.user.role,
				updatedAt: userData.user.updatedAt,
				version: userData.user.version,
				name: userData.user.name,
				secondname: userData.user.secondname,
			},
		};
		localStorage.setItem("uResaNinja", JSON.stringify(userDataModified));
		document.cookie = `uResaNinja=${JSON.stringify(userDataModified)}`;
	}
};

/**
 * set user cookie info
 */
export const logoutUserCookie = async function () {
	localStorage.removeItem("uResaNinja");
	document.cookie =
		"uResaNinja=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};
